import { Record, Union } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, class_type, list_type, string_type, union_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.19.0/Result.js";
import { Faq_Faq_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { Remote$1, Remote$1_$reflection } from "../../../../Bfs.Web.Portale/Types.fs.js";

export class Page extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["Faq"];
    }
}

export function Page_$reflection() {
    return union_type("Faq.Types.Page", [], Page, () => [[]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoadKategorien", "KategorienLoaded", "LoadFaq", "FaqLoaded", "SearchForFaq"];
    }
}

export function Msg_$reflection() {
    return union_type("Faq.Types.Msg", [], Msg, () => [[], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(string_type), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", list_type(string_type)]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", string_type]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(Faq_Faq_$reflection()), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", list_type(Faq_Faq_$reflection())]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", string_type]]]);
}

export class FaqDisplayMode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Unknown", "Kategorie", "Search"];
    }
}

export function FaqDisplayMode_$reflection() {
    return union_type("Faq.Types.FaqDisplayMode", [], FaqDisplayMode, () => [[], [["Item", string_type]], [["Item", string_type]]]);
}

export class Model extends Record {
    constructor(Kategorien, Faqs, SelectedKategorie) {
        super();
        this.Kategorien = Kategorien;
        this.Faqs = Faqs;
        this.SelectedKategorie = SelectedKategorie;
    }
}

export function Model_$reflection() {
    return record_type("Faq.Types.Model", [], Model, () => [["Kategorien", Remote$1_$reflection(list_type(string_type))], ["Faqs", Remote$1_$reflection(list_type(Faq_Faq_$reflection()))], ["SelectedKategorie", FaqDisplayMode_$reflection()]]);
}

export function Model_get_Init() {
    return new Model(new Remote$1(1, []), new Remote$1(1, []), new FaqDisplayMode(0, []));
}

//# sourceMappingURL=Types.fs.js.map
